import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ObjectTargetsTranslator } from "./ObjectTargetsTranslator";
import { LegacyLinkedPageObjectTranslator } from "./LegacyLinkedPageObjectTranslator";

export class TranscribeBehaviorTranslator extends ObjectTargetsTranslator<ILinkedPageObjectSpecifiable> {
  constructor() {
    super("text-paste", new LegacyLinkedPageObjectTranslator());
  }
}
